<div
  class="test-list-widget"
  [ngSwitch]="def.widgetType"
  *ngIf="isDataAvailable()"
  [ngClass]="{ 'no-border': def.noBorder }"
>
  <div class="widget-wrapper">
    <mat-card>
      <ng-template #action>
        <ng-container class="headline" *ngIf="!def.noHeader">
          <ng-container class="headline-wrapper">
            <ng-container class="headline-action-button" *ngIf="def.actions.bulk && hasManageTest">
              <button
                [matMenuTriggerFor]="menu"
                mat-button
                class="action-button mat-menu-trigger btn-menu-trigger actions-btn mat-button mat-button-base"
                (click)="generateBatchActionState()"
                aria-label="Open menu"
                [disabled]="isActionsDisabled"
              >
                <span class="mat-button-wrapper"><i class="material-icons">more_horiz</i></span>
              </button>
              <mat-menu #menu="matMenu">
                <div class="mat-dropdown-menu-with-icons">
                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    *ngIf="def.actions.bulk.remove && batchActionState"
                    (click)="
                      sendAction({ method: def.actions.bulk.remove.method, action: 'remove' })
                    "
                    aria-label="Remove"
                    [ngClass]="{
                      'disable-button': batchActionState.started
                    }"
                    [disabled]="batchActionState.started"
                    [matTooltipPosition]="'above'"
                    [matTooltip]="batchActionState.started ? 'Running test cannot be removed' : ''"
                  >
                    <span>Remove</span>
                  </button>

                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    *ngIf="def.actions.bulk.revoke"
                    (click)="
                      sendAction({
                        method: def.actions.bulk.revoke.method,
                        path: def.actions.bulk.revoke.path,
                        action: 'revoke'
                      })
                    "
                    aria-label="Revoke"
                  >
                    <span>Revoke</span>
                  </button>

                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    *ngIf="def.actions.bulk.stop && batchActionState"
                    (click)="
                      sendAction({
                        method: def.actions.bulk.stop.method,
                        path: def.actions.bulk.stop.path,
                        action: 'stop'
                      })
                    "
                    aria-label="Stop monitor"
                    [ngClass]="{
                      'disable-button':
                        (batchActionState.stopped && !batchActionState.started) ||
                        batchActionState.readyState
                    }"
                    [disabled]="
                      (batchActionState.stopped && !batchActionState.started) ||
                      batchActionState.readyState
                    "
                  >
                    <span>Stop</span>
                  </button>

                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    *ngIf="def.actions.bulk.start && batchActionState"
                    (click)="
                      sendAction({
                        method: def.actions.bulk.start.method,
                        path: def.actions.bulk.start.path,
                        action: 'start'
                      })
                    "
                    aria-label="Start monitor"
                    [ngClass]="{
                      'disable-button':
                        (batchActionState.started && !batchActionState.stopped) ||
                        batchActionState.agentDestroyed ||
                        batchActionState.readyState
                    }"
                    [disabled]="
                      (batchActionState.started && !batchActionState.stopped) ||
                      batchActionState.agentDestroyed ||
                      batchActionState.readyState
                    "
                  >
                    <span>Start</span>
                  </button>
                </div>
              </mat-menu>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-template>

      <div class="device-counters">
        <div
          class="count-item"
          *ngFor="let item of testStatusCounters"
          [ngClass]="{ selected: item.id === selectedFilterItem }"
          (click)="counterSelected(item)"
        >
          <div class="count" [class]="item.id">{{ item.count }}</div>
          <div class="item-label">{{ item.label }}</div>
        </div>
      </div>
      <progress-spinner *ngIf="isLoading"> </progress-spinner>
      <div class="content">
        <viavi-table
          [tableConfigurations]="table"
          [isActionEnabled]="hasManageTest && def.isActionEnabled"
          (rowClicked)="onTableRowClick($event)"
          (sendRowAction)="onRowActionClick($event)"
          [template]="action"
          [resetCheckbox]="resetCheckbox"
          (onDataFiltered)="onTableFiltered($event)"
        >
        </viavi-table>
      </div>
    </mat-card>
  </div>
</div>
